export const WORKFLOW_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

export const EXECUTION_STATUS_OPTIONS = [
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "running", label: "Running" },
];

export const EXECUTION_STATUS_COLORS: Record<string, string> = {
  completed: "success",
  failed: "error",
  running: "processing",
};

export const WORKFLOW_LIST_FETCH_LIMIT = 1000;
